const ACCESS_TIMESTAMP = "accessTimestamp";
const INTENT_ROUTE = "intentRoute";
// Formula for all following 3 const: hours * minutes * second * millisecond
// Access CWA time will be expired in 2 hours before force user to select branch
const ACCESS_TIMESTAMP_EXPIRY = !isNaN(parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_EXPIRY)) ?
  parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_EXPIRY) : 2 * 60 * 60 * 1000;
// A threshold used to compare whether to extends user current access timestamp, default to 30 minutes
const ACCESS_TIMESTAMP_THRESHOLD = !isNaN(parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_THRESHOLD)) ?
  parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_THRESHOLD) : 30 * 60 * 1000;
// if user current access timestamp hit threshold and not expired, then extend user current access timestamp to 30 minutes
const ACCESS_TIMESTAMP_EXTEND = !isNaN(parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_EXTEND)) ?
  parseInt(process.env.VUE_APP_ACCESS_TIMESTAMP_EXTEND) : 30 * 60 * 1000;
console.log(`ATEP: ${ACCESS_TIMESTAMP_EXPIRY}, ATT: ${ACCESS_TIMESTAMP_THRESHOLD}, ATED: ${ACCESS_TIMESTAMP_EXTEND}`);

function getAccessTimestamp() {
  return localStorage.getItem(ACCESS_TIMESTAMP);
}

function getAccessTimestampObj() {
  const accessTimestamp = getAccessTimestamp();

  return accessTimestamp ? new Date(accessTimestamp) : new Date();
}

function getRemainingAccessTimeStamp() {
  const currentDateObj = new Date();
  const accessTimestampDateObj = getAccessTimestampObj();

  return ACCESS_TIMESTAMP_EXPIRY - (currentDateObj - accessTimestampDateObj);
}

function setAccessTimestamp(value) {
  localStorage.setItem(ACCESS_TIMESTAMP, value);
}

function setExtendAccessTimeStamp() {
  const accessTimestampDateObj = getAccessTimestampObj();
  const extendedTimestamp = new Date(accessTimestampDateObj.getTime() + ACCESS_TIMESTAMP_EXTEND);

  setAccessTimestamp(extendedTimestamp.toISOString());
}

function isAccessTimestampExpired() {
  const currentDateObj = new Date();
  const accessTimestampDateObj = getAccessTimestampObj();

  return !getAccessTimestamp() ||
    (
      currentDateObj - accessTimestampDateObj >= ACCESS_TIMESTAMP_EXPIRY || // Expired more than 2 hours ago
      accessTimestampDateObj - currentDateObj >= ACCESS_TIMESTAMP_EXPIRY    // User manipulate device time and set more than 2 hours in the future
    )
}

function isAccessTimestampHitThreshold() {
  return getRemainingAccessTimeStamp() <= ACCESS_TIMESTAMP_THRESHOLD;
}

function getIntentRoute() {
  return JSON.parse(
    sessionStorage.getItem(INTENT_ROUTE)
  );
}

function setIntentRoute(path, name, params, query) {
  sessionStorage.setItem(
    INTENT_ROUTE,
    JSON.stringify({ path, name, params, query })
  );
}

function removeIntentRoute() {
  sessionStorage.removeItem(INTENT_ROUTE);
}


export {
  getAccessTimestamp,
  getAccessTimestampObj,
  getRemainingAccessTimeStamp,
  setAccessTimestamp,
  setExtendAccessTimeStamp,
  isAccessTimestampExpired,
  isAccessTimestampHitThreshold,
  getIntentRoute,
  setIntentRoute,
  removeIntentRoute
};
